import * as React from 'react';
import * as styles from './styles.css';

import { IMainScreenProps } from '../../types/public';
import { Aside } from '../Aside';
import { FormHeader } from '../FormHeader';

export function MainScreenDesktop(props: IMainScreenProps) {
  const { backToPage, main, progressBar, showGoBackBtn, handleGoBack, goBackText } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['aside']}>
        <Aside backToPage={backToPage} />
      </div>
      <div className={styles['main']}>
        <div className={styles['header']}>
          <FormHeader
            progressBar={progressBar}
            showGoBackBtn={showGoBackBtn}
            handleGoBack={handleGoBack}
            goBackText={goBackText}
          />
        </div>
        <div>{main}</div>
      </div>
    </div>
  );
}
